/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Credits_UpgradeInputs */

const en_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade for more`)
};

const de_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade fuer mehr`)
};

const fr_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passez au superieur`)
};

const es_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora para mas`)
};

const it_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a un piano superiore`)
};

const nl_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade voor meer`)
};

const pl_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulepsz, aby uzyskac wiecej`)
};

const fi_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Päivitä saadaksesi lisää`)
};

const da_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opgrader for flere`)
};

const sv_sidebar_credits_upgrade = /** @type {(inputs: Sidebar_Credits_UpgradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppgradera for fler`)
};

/**
* | output |
* | --- |
* | "Upgrade for more" |
*
* @param {Sidebar_Credits_UpgradeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const sidebar_credits_upgrade = /** @type {((inputs?: Sidebar_Credits_UpgradeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Credits_UpgradeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sidebar_credits_upgrade(inputs)
	if (locale === "fr") return fr_sidebar_credits_upgrade(inputs)
	if (locale === "es") return es_sidebar_credits_upgrade(inputs)
	if (locale === "it") return it_sidebar_credits_upgrade(inputs)
	if (locale === "nl") return nl_sidebar_credits_upgrade(inputs)
	if (locale === "pl") return pl_sidebar_credits_upgrade(inputs)
	if (locale === "fi") return fi_sidebar_credits_upgrade(inputs)
	if (locale === "da") return da_sidebar_credits_upgrade(inputs)
	if (locale === "sv") return sv_sidebar_credits_upgrade(inputs)
	return en_sidebar_credits_upgrade(inputs)
});